import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Style/App.css';
import { API_URL } from '../config/api';

export default function Confirm() {
  const loc = useLocation();
  const nav = useNavigate();
  const params = new URLSearchParams(loc.search);
  const email  = params.get('email') || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  axios.defaults.withCredentials = true;

  const handle = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axios.post(
        `${API_URL}/auth/confirm`,
        { email, code },
        { withCredentials: true }
      );

      // Check if there's a message about pending approval
      if (response.data.message) {
        setSuccess(response.data.message);
        // Don't navigate automatically, let user click button to go back
      } else {
        nav(`/home?email=${encodeURIComponent(email)}`);
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <div className="loginPage">
      <img
        src="/GradyStar.png"
        alt="Logo"
        className="logo"
      />
      <div className="loginForm">
        {error && <div className="text-danger mb-2" style={{color: '#d32f2f', marginBottom: '10px'}}>{error}</div>}
        {success && (
          <div style={{color: '#2e7d32', marginBottom: '15px', padding: '15px', backgroundColor: '#e8f5e8', borderRadius: '4px', fontSize: '14px', lineHeight: '1.5'}}>
            <strong> Email Confirmed Successfully!</strong>
            <br /><br />
            Your account request has been sent to the administrator for approval.
            <br /><br />
            <strong>What happens next:</strong>
            <ul style={{margin: '10px 0', paddingLeft: '20px', textAlign: 'left'}}>
              <li>An administrator will review your request</li>
              <li>You will receive an email notification when approved</li>
              <li>Once approved, you can log in with your credentials</li>
            </ul>
            <div style={{textAlign: 'center', marginTop: '15px'}}>
              <button
                onClick={() => nav('/')}
                className="modern-btn"
                style={{backgroundColor: '#0b3f1f', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px'}}
              >
                Back to Login
              </button>
            </div>
          </div>
        )}
        <h2 className="text-center"><strong>Confirm Email</strong></h2>
        <p style={{marginBottom: "15px", fontSize: "15px"}}>Code sent to <strong>{email}</strong></p>
        {!success && (
          <form onSubmit={handle}>
            <div style={{marginBottom: "10px"}}>
              <input
                placeholder="Confirmation code"
                className="modern-input"
                value={code}
                onChange={e => setCode(e.target.value)}
                required
              />
            </div>
            <button className="modern-btn">
              Confirm
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
